import styled from 'styled-components';
import // COLOR,
// FONT
'assets';

export const TermsOfServiceContainerStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  max-width: 1100px;
  margin: auto;
  padding: 0 15px;
  .title {
    text-align: center;
  }
  .group_number_text {
    list-style-type: decimal;
  }
  .group_word_text {
    list-style-type: lower-latin;
  }
  .group_roman_text {
    list-style-type: lower-roman;
  }
  .title_normal {
    font-family: prompt_medium;
  }
`;
